<template>
  <b-modal
    ref="newRecipeModal"
    centered
    size="md"
    title="Add new recipe"
    hide-header-close
    scrollable
    footer-bg-variant=""
    @hidden="
      unselectRecipe(),
      unselectRecipeGroup()
    ">
    <no-data-found
      v-if="uninstalledRecipesListEmpty"
      :text="'No recipes to install'" />
    <b-form
      v-else
      @submit.stop.prevent>
      <b-form-group
        id="recipe-server"
        label="Recipe"
        label-for="recipe-input"
        class="mb-2">
        <b-form-select v-model="selectedRecipe">
          <template #first>
            <b-form-select-option
              :value="defaultSelectedRecipe"
              disabled>
              Please select recipe
            </b-form-select-option>
          </template>
          <b-form-select-option
            v-for="recipe in uninstalledRecipesList"
            :key="`recipe-${recipe._id}`"
            :value="recipe">
            {{ recipe.name }}
          </b-form-select-option>
        </b-form-select>
      </b-form-group>
    </b-form>

    <template #modal-footer>
      <div class="d-flex w-100">
        <b-button
          variant="outline-secondary"
          size="md"
          @click="hideModal('newRecipeModal')">
          Cancel
        </b-button>
        <b-button
          :disabled="!selectedRecipeExist || recipeGroupsResponses('addNewRecipe')"
          :class="{ 'cursor-not-allowed' : !selectedRecipeExist }"
          variant="primary"
          size="md"
          class="ml-auto"
          @click="addNewRecipe">
          Submit
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {
  // mutations
  SELECT_RECIPE,
  UNSELECT_RECIPE,

  // defaults
  DEFAULT_SELECTED_RECIPE,
} from '@/core/services/store/recipes.module'
import {
  // actions
  GET_RECIPE_GROUP,
  GET_RECIPE_GROUP_RECIPES,
  ADD_NEW_RECIPE,

  // mutations
  UNSELECT_RECIPE_GROUP
} from '@/core/services/store/recipes-groups.module'
import { mapGetters } from 'vuex'
import { eventBus } from '@/main'
import { showModal, hideModal } from '@/core/utils'

export default {
  name: 'ModalNewRecipe',
  data() {
    return {
      defaultSelectedRecipe: { ...DEFAULT_SELECTED_RECIPE },

      showModal,
      hideModal,
    }
  },
  computed: {
    ...mapGetters([
      'uninstalledRecipesList',
      'uninstalledRecipesListEmpty',
      'recipesEmpty',
      'selectedRecipeId',
      'recipeVersions',
      'recipeVersionsPending',
      'selectedRecipeGroupId',
      'selectedRecipeVersionId',
      'selectedRecipeExist',
      'beautifiedVersionTitle',
      'recipesResponses',
      'recipeGroupsResponses',
    ]),

    selectedRecipe: {
      get() {
        return this.$store.getters.selectedRecipe
      },
      set(recipe) {
        this.$store.commit(SELECT_RECIPE, recipe)
      },
    },
  },
  mounted() {
    eventBus.$on('openModal', type => { this.showModal(type) })
  },
  destroyed() {
    eventBus.$off('openModal')
  },
  methods: {
    getRecipeGroup() {
      this.$store.dispatch(GET_RECIPE_GROUP, {
        id: this.selectedRecipeGroupId
      })
    },

    getRecipeGroupRecipes() {
      this.$store.dispatch(GET_RECIPE_GROUP_RECIPES, {
        id: this.selectedRecipeGroupId,
        isShowing: false,
      })
    },

    unselectRecipe() {
      this.$store.commit(UNSELECT_RECIPE)
    },

    unselectRecipeGroup() {
      this.$store.commit(UNSELECT_RECIPE_GROUP)
    },
    
    addNewRecipe() {
      this.$store.dispatch(ADD_NEW_RECIPE)
        .then(() => {
          this.getRecipeGroup()
          this.getRecipeGroupRecipes()
        })
        .finally(() => {
          this.unselectRecipeGroup()
          this.hideModal('newRecipeModal')
        })
    },
  }
}
</script>
